import React from 'react';
import Card_icon from '../../Components/assets/images/board_icon.svg';

const StatCard = (props) => {
  return (
    <div style={{height:'100%', borderRadius:'30px'}} className='revenue-box stat_card br-24'>
        <div className='stat_img'>
            <img src={props?.img} alt='img' className='mw-35' />
        </div>
        <div className='revenue-heading'>
            {props?.heading}
        </div>
        <div className='revenue_price fz-32 fw-bold'>
            {/* <span className='dollar'>$</span> */}
            {props?.number}
        </div>
    </div>
  )
}

export default StatCard
